import { useRouter } from "next/router";
import TranslatedMessage from "./TranslatedMessage";

const BackButton = (props) => {
  const router = useRouter();
  return (
    <>
      <button className="pd-btn pd-back-button" onClick={() => router.back()}>
        <span className="long-arrow-left"></span>
        <span className="pd-back-button__text">
          <TranslatedMessage id="sections.backbutton.action.title" />
        </span>
      </button>
    </>
  );
};

export default BackButton;
